// GTM Events on quote form submit
/*document.addEventListener('click', function(e) {
    let btn = e.target.closest('[type=submit]');
    if(btn) {
        if(btn.closest('form[name=fxy_fsa_catdog]')) {
            const form = document.querySelector('form[name=fxy_fsa_catdog]');
            var jauge = document.querySelector('.jauge');
            var step = 0;
            if(jauge) {
                step = jauge.classList.contains('step-3') ? 3 : (jauge.classList.contains('step-2') ? 2 : 1);
                if(form.getAttribute('data-name') !== 'souscription') {
                    var event = {
                        "event": "devis_step_"+(step - 1)+"_submitted",
                    }
                    if(step === 2) {
                        var parents = document.querySelectorAll("[id^=step-formula-]");
                        if(parents) {
                            event.fields = [];
                            Array.from(parents).forEach(function(el) {
                                var fields = {},
                                    parentId = el.id.replace('step-formula-', ''),
                                    formula = document.querySelector('[name="fxy_fsa_catdog[animals]['+parentId+'][animalFormula]"]:checked'),
                                    category = document.querySelector('[name="fxy_fsa_catdog[animals]['+parentId+'][animalRC]"]:checked');
                                if(formula) {
                                    fields.formula = formula.value;
                                }
                                if(category) {
                                    fields.category = category.value;
                                }
                                event.fields.push(fields); 
                            });
                        }
                    }
                    if(typeof dataLayer !== "undefined") {
                        event.orderid = getOrderID();
                        dataLayer.push(event);
                        if(step === 2) {
                            event.event = "strat_completion_devis";
                            dataLayer.push(event);
                        }
                    }
                }
            }
        }
    } else {
        let ctrl = e.target.closest('.control--radio');
        if(ctrl) {
            let input = ctrl.querySelector('input');
            if(input) {
                let label = input.getAttribute('data-formula-label');
                if(label) {
                    var event = {
                        "event": "clic_formule_"+label
                    }
                    if(typeof dataLayer !== "undefined") {
                        dataLayer.push(event);
                    }
                }
            }
        }
    }

});*/

// Listen all clicks on elements with data-attribute data-trck
document.addEventListener('click', function(e) {
    if(typeof dataLayer !== "undefined") {
        var target = e.target.closest('[data-trck]');
        if(target) {
            clickTracking(target);
        }
    }
});

// GTM event by data-attribute function
function clickTracking(element) {
    var data = element.getAttribute('data-trck');
    if(data) {
        data = JSON.parse(data);
        if(data.hasOwnProperty('fields')) {
            data.fields = getTrackedFields(data.fields, data.hasOwnProperty('parent') ? data.parent : false);
        }
        dataLayer.push(data);
    }
}

function getTrackedFields(fields, parent) {
    var values = [];
    if(fields === 'animal') {
        values = getAnimalInfo();
    } else {
        if(!fields.isArray()) {
            fields = [fields];
        }
        fields.forEach(function(field) {
            var el = document.querySelector(field);
            if(el) {
                values[el] = el.value;
            }
        });
    }
    return values;
}

function getAnimalInfo() {
    var animalBox = document.querySelector('.choix-animal'),
        infos = [];
    if(animalBox) {
        var animalBoxId = animalBox.id;
        if(animalBoxId) {
            animalBoxId = animalBoxId.replace('animal-', '');
            var name = 'fxy_fsa_catdog[animals]['+animalBoxId+']';
            var fields = document.querySelectorAll('[name^="'+name+'"]');
            if(fields) {
                Array.from(fields).forEach(function(el) {
                    var key = el.name.replace(name+'[', '').replace(']', '');
                    infos[key] = key == "animalType" ? el.getAttribute('data-type-animal') : el.value;
                    var race = ['animalRaceCat','animalRaceDog'];
                    if(race.includes(key)) {
                        infos[key] = el.options[el.selectedIndex].text;
                    }
                });
            }
        }
    }
    return infos;
}

function getOrderID() {
    var localOrderid = '';
    if(typeof window.orderid !== 'undefined') {
        localOrderid = window.orderid;
        localStorage.setItem('orderid',localOrderid);
    } else {
        localOrderid = localStorage.getItem('orderid');
    }
    return localOrderid;
}